<div class="flex flex-col gap-y-6">
  <div class="flex items-center justify-between">
    <app-page-headline
      [headline]="'pages.addressMaster.headline' | translate"
      [isLoading]="isLoading"
      [count]="total"
    />
    <app-button
      data-test-id="openCreateSnapshotDialog"
      type="primary"
      (trigger)="snapshotDialog.showModal()"
    >
      <svg-icon class="size-5" src="assets/icons/Images/camera-01.svg" />
      {{ 'pages.addressMaster.snapshotCreation.openButton' | translate }}
    </app-button>
  </div>

  <div class="flex flex-col gap-6">
    <form class="mb-4" nz-form nzLayout="vertical" [formGroup]="filterForm">
      <formly-form
        [form]="filterForm"
        [fields]="filterFields"
        [model]="filterModel"
        (modelChange)="onFilterChange()"
      />
    </form>

    <app-master-addresses
      [tableData]="tableData"
      [sword]="sword"
      [total]="total"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [isLoading]="isLoading"
      [defaultSorting]="activeSorting"
      [extraColumns]="[
        {
          key: 'versionNumber',
          label: 'pages.addressMaster.table.version.label' | translate,
          width: '96px',
          fixRight: true,
        },
        {
          key: 'actions',
          label: 'pages.addressMaster.table.actions.label' | translate,
          width: '56px',
          align: 'right',
          fixRight: true,
          cellTemplate: actionCellTemplate,
          sort: false,
        },
      ]"
      (changeHandler)="changeTableHandler($event)"
    />
  </div>
</div>

<ng-template
  #actionCellTemplate
  let-currentRow="currentRow"
  [typedTemplate]="typeToken"
>
  <app-button
    class="inline-block"
    data-test-id="testButton"
    type="primary"
    shape="circle"
    [title]="'pages.addressMaster.table.actions.view.title' | translate"
    [routerLink]="[currentRow.referenceId]"
  >
    <svg-icon src="assets/icons/General/eye.svg" />
  </app-button>
</ng-template>

<dialog
  #snapshotDialog
  data-test-id="snapshotDialog"
  (mousedown)="onDialog($event)"
>
  <div
    class="flex max-w-[800px] flex-col items-end gap-6 rounded-xl bg-white px-8 py-6"
  >
    <div class="prose w-full">
      <h2 class="flex items-start gap-3 text-red-600">
        <span class="pt-1">{{
          'pages.addressMaster.snapshotCreation.title' | translate
        }}</span>
      </h2>
    </div>
    @if (snapshotDialogLoading) {
      <svg-icon
        data-test-id="createSnapshotLoading"
        src="assets/icons/General/loading-01.svg"
        class="animate-spin"
      />
    } @else {
      <form
        data-test-id="createSnapshotForm"
        class="mb-4"
        nz-form
        nzLayout="vertical"
        [formGroup]="dialogForm"
        (ngSubmit)="createSnapshot()"
      >
        <formly-form
          [form]="dialogForm"
          [fields]="dialogFields"
          [model]="dialogModel"
        />
        <div class="flex justify-between gap-8">
          <app-button data-test-id="cancelSnapshot" type="outline" (trigger)="stopSnapshotCreation()">
            {{
              'pages.addressMaster.snapshotCreation.cancelButton' | translate
            }}
          </app-button>
          <app-button
            data-test-id="createSnapshot"
            type="primary"
            htmlType="submit"
          >
            {{ 'pages.addressMaster.snapshotCreation.saveButton' | translate }}
          </app-button>
        </div>
      </form>
    }
  </div>
</dialog>
